var map = {
	"./love-paws-homestay-dogs.jpg": "dfdb",
	"./love-paws-homestay-grooming.jpg": "f219",
	"./love-paws-homestay-omana.jpg": "9a61",
	"./love-paws-homestay-swimming.jpg": "a56f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e299";